import React from "react";
import "@fontsource-variable/public-sans";
import Layout from "./src/layouts/index.js";
import { getHomeScrollPosition } from "./src/utils/scroll.js";

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

// --- Scroll position persistence for back/forward navigation ---
const SCROLL_STORAGE_KEY = "bespoke-scroll-positions";

const loadScrollMap = () => {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(SCROLL_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

const saveScrollMap = (map) => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    // ignore storage errors
  }
};

// Normalize paths to avoid mismatches between "/team" and "/team/".
const normalizePath = (path) => {
  if (!path) return "/";
  if (path === "/") return "/";
  return path.endsWith("/") ? path.slice(0, -1) : path;
};

const saveScrollForPath = (path) => {
  const key = normalizePath(path);
  const map = loadScrollMap();
  map[key] = [window.scrollX || 0, window.scrollY || 0];
  saveScrollMap(map);
};

const getScrollForPath = (path) => {
  const key = normalizePath(path);
  const map = loadScrollMap();
  return map[key];
};

let navigationWasPop = false;

export const onClientEntry = () => {
  if (typeof window === "undefined") return;
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
  window.addEventListener("popstate", () => {
    navigationWasPop = true;
  });
};

export const onPreRouteUpdate = ({ prevLocation }) => {
  if (typeof window === "undefined") return;
  if (prevLocation) {
    const key = `${prevLocation.pathname}${prevLocation.search}`;
    saveScrollForPath(key);
  }
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return;

  // allow default behavior for in-page anchors
  if (location?.hash) {
    navigationWasPop = false;
    return;
  }

  const homePaths = ["/", "/pl/home"];
  const hasHomeScroll = getHomeScrollPosition();
  if (hasHomeScroll && homePaths.includes(location.pathname)) {
    navigationWasPop = false;
    return;
  }

  const key = `${location.pathname}${location.search}`;
  const saved = getScrollForPath(key);

  if (navigationWasPop && saved) {
    window.requestAnimationFrame(() => {
      window.scrollTo(saved[0], saved[1]);
    });
  } else {
    window.scrollTo(0, 0);
  }

  navigationWasPop = false;
};
